/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ObservationstypeGroupsidObservationTypeGroup from './ObservationstypeGroupsidObservationTypeGroup';

/**
 * The TypeGroupsIdBody model module.
 * @module model/TypeGroupsIdBody
 * @version v0.3
 */
export default class TypeGroupsIdBody {
  /**
   * Constructs a new <code>TypeGroupsIdBody</code>.
   * @alias module:model/TypeGroupsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TypeGroupsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TypeGroupsIdBody} obj Optional instance to populate.
   * @return {module:model/TypeGroupsIdBody} The populated <code>TypeGroupsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TypeGroupsIdBody();
      if (data.hasOwnProperty('observation_type_group'))
        obj.observationTypeGroup = ObservationstypeGroupsidObservationTypeGroup.constructFromObject(data['observation_type_group']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ObservationstypeGroupsidObservationTypeGroup} observationTypeGroup
 */
TypeGroupsIdBody.prototype.observationTypeGroup = undefined;

